module.exports = __webpack_public_path__ + "fonts/baronsans-roman-webfont.3fbc56d5.woff2";